import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { useRatings } from '../../hooks/useRatings';
import { useState } from 'react';
const CalificationPopUp = (props) => {
    const { calificacion, id, handleStop, handleNext, nextResource } = props;

    // Hooks
    const { isCalificated, postRatings, handleCalificated } = useRatings();

    handleStop();

    // State
    const [activeCalification, setActiveCalification] = useState(
        calificacion || null
    );

    // Functions
    const handleCalification = (rating) => {
        setActiveCalification(rating);
        postRatings(id, rating);
    };

    const resetModal = () => {
        setActiveCalification(null);
        handleCalificated(false);
        if (nextResource) {
            handleNext();
        }
    };

    return (
        <CalificationContent>
            {isCalificated ? (
                <Message>
                    <p>¡Gracias por calificarnos!</p>
                </Message>
            ) : (
                <>
                    <Header>
                        <TitlesWrapper>
                            <Title>¿Qué te pareció el video?</Title>
                            <Subtitle>Tu opinión nos ayuda a mejorar.</Subtitle>
                        </TitlesWrapper>
                    </Header>

                    <Footer>
                        <VoteButton onClick={() => handleCalification(10)}>
                            {activeCalification === 10 ? (
                                <img
                                    src="/assets/aden/icon-smile-solid.svg"
                                    alt="logo"
                                />
                            ) : (
                                <img
                                    src="/assets/aden/icon-smile.svg"
                                    alt="logo"
                                />
                            )}
                            <p>Me interesa</p>
                        </VoteButton>
                        <VoteButton
                            rotate="180deg"
                            onClick={() => handleCalification(5)}
                        >
                            <div>
                                {activeCalification === 5 ? (
                                    <img
                                        src="/assets/aden/icon-smile-solid.svg"
                                        alt="logo"
                                    />
                                ) : (
                                    <img
                                        src="/assets/aden/icon-smile.svg"
                                        alt="logo"
                                    />
                                )}
                            </div>
                            <p>Me da igual</p>
                        </VoteButton>
                        <VoteButton onClick={() => handleCalification(1)}>
                            {activeCalification === 1 ? (
                                <img
                                    src="/assets/aden/icon-angry-solid.svg"
                                    alt="logo"
                                />
                            ) : (
                                <img
                                    src="/assets/aden/icon-angry.svg"
                                    alt="logo"
                                />
                            )}
                            <p>No me gusta</p>
                        </VoteButton>
                    </Footer>
                </>
            )}
            <ButtonCancel onClick={resetModal}>
                <CloseIcon />
            </ButtonCancel>
        </CalificationContent>
    );
};

export default CalificationPopUp;

const CalificationContent = styled.div`
    width: 380px;
    position: relative;
    height: 180px;
    padding: 1rem;
    gap: 2rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: space-between;
    justify-content: space-between;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0 0;
`;

const ButtonCancel = styled.button`
    position: absolute;
    top: 10px;
    right: 1rem;
    cursor: pointer;
    svg {
        color: #fff;
    }
`;
const TitlesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    align-items: flex-start;
`;
const Title = styled.p`
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
`;

const Subtitle = styled.p`
    font-size: 0.9rem;
    color: #fff;
`;
const Footer = styled.div`
    width: 100%;
    display: flex;
    gap: 2rem;
    justify-content: center;
    align-items: center;
`;

const VoteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    flex-direction: column;
    p {
        font-size: 0.9rem;
        color: #fff;
    }
    cursor: pointer;
    div {
        transform: ${(props) =>
            props.rotate ? `rotate(${props.rotate})` : 'none'};
    }
`;

const Message = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        font-size: 1.1rem;
        color: #fff;
        font-weight: 600;
    }
`;
